import React from 'react'

import {
  CircularProgress,
  LinearProgress,
  Typography,
  styled,
} from '@mui/material'

const getPercentString = (value) => {
  if (value == null || isNaN(value) || !isFinite(value)) return '0.00%'
  return value.toFixed(2) + '%'
}

const Progress = styled(LinearProgress)(({ theme }) => ({
  width: '100%',
  height: 20,
  borderRadius: 20,
  backgroundColor: theme.palette.secondary.main,
  bar: {
    borderRadius: 20,
  },
}))

const UploadProgress = ({ value }) => (
  <>
    <Typography paragraph>Uploading...</Typography>
    <Progress variant="determinate" value={value} />
    <Typography paragraph variant="body2" color="textPrimary">
      {getPercentString(value)}
    </Typography>
    {value === 100 && (
      <>
        <Typography paragraph>Finalising upload...</Typography>
        <CircularProgress />
      </>
    )}
  </>
)

export default UploadProgress
